/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {SoundPlayer} from "../sound/SoundPlayer";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";

export class NormalWin implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _countTo:number;
    private _hasWin:boolean;
    private _countFrom:number;
    private _lastNormalWinConfig:IWinRatioConfig;
    private _duration:number;
    private _sound:string;

    constructor(lastNormalWinConfig:IWinRatioConfig, stagger?:number, abortStagger?:number) {
        this._lastNormalWinConfig = lastNormalWinConfig;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
        this._hasWin =  data.singleWin > 0 && !data.isBigWin;
        /*
        if(!data.currentWinRatioConfig && data.singleWin <= 0) {
            return;
        }

        this._hasWin = true;
        let config:IWinRatioConfig = data.currentWinRatioConfig!;
        if(data.currentWinRatio > this._lastNormalWinConfig.ratio) {
            config = this._lastNormalWinConfig;
        }

        this._countFrom = 0;
        this._countTo = data.playedBetValue * config.ratio;
        this._duration = config.duration * 3;
        this._sound = config.sound!;*/
    }

    public getAnimation(data:ParsedGameData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }
        //console.log("WR Conf:");
        //console.log(data.currentWinRatioConfig);
        const countStart:TimelineLite = WinterHoardGameModuleConfig.countUpView.getWinStepAnimation(0, data.singleWin, data.currentWinRatioConfig!.duration);

        const tl:TimelineLite = new TimelineLite();
        // #287
        if (!WinterHoardGameConfig.instance.WIN_BELOW_STAKE) {
            tl.add(() => {
                //TODO- Fix this
                SoundPlayer.playNormalWinSound(data.currentWinRatioConfig!);
            });
        }

        tl.add(countStart);

        return tl;
    }

    /*

        public abort(isActive:boolean, data:ParsedServerData):Timeline | null {
            const tl:TimelineLite = new TimelineLite();
            tl.add(new TweenLite(this, 1, {}));
            return tl;
        }
    */

}